import { render, staticRenderFns } from "./SearchResultItemPost.vue?vue&type=template&id=670a379b&scoped=true&"
import script from "./SearchResultItemPost.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemPost.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemPost.vue?vue&type=style&index=0&id=670a379b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a379b",
  null
  
)

export default component.exports